export const getSurvey = async secretToken => {
  const response = await fetch(
    `${process.env.REACT_APP_GET_SURVEY_ENDPOINT}?secret=${secretToken}`
  )
  return await response.json()
}

export const submitAnswers = async formData => {
  const body = JSON.stringify(formData)
  const params = {
    method: 'post',
    body,
  }
  const response = await fetch(
    process.env.REACT_APP_SUBMIT_SURVEY_ANSWERS_ENDPOINT,
    params
  )
  return await response.json()
}



// WEBPACK FOOTER //
// ./src/api.js